export const ICON_MAP = {
  'checkmark-square': CheckmarkSquareIcon,
  'radio-button-checked': RadioButtonCheckedIcon,
  'yes-no': YesNoIcon,
};

export const CustomIcon = ({ name, ...props }) => {
  const IconComponent = ICON_MAP[name];
  if (!IconComponent) return null;
  return <IconComponent {...props} />;
};

function CheckmarkSquareIcon({ width = 24, height = 24, ...props }) {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width={24} height={24} rx="4" fill="var(--icon-fill)" />
      <path d="M9 12.75L11.25 15L15 9.75" stroke="var(--icon-stroke)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <rect x="3.75" y="3.75" width="16.5" height="16.5" rx="1.25" stroke="var(--icon-stroke)" strokeWidth="1.5" />
    </svg>
  );
}

function RadioButtonCheckedIcon({ width = 24, height = 24, ...props }) {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width={24} height={24} rx="4" fill="var(--icon-fill)" />
      <path
        d="M12 3C10.22 3 8.47991 3.52784 6.99987 4.51677C5.51983 5.50571 4.36628 6.91131 3.68509 8.55585C3.0039 10.2004 2.82567 12.01 3.17294 13.7558C3.5202 15.5016 4.37737 17.1053 5.63604 18.364C6.89471 19.6226 8.49836 20.4798 10.2442 20.8271C11.99 21.1743 13.7996 20.9961 15.4442 20.3149C17.0887 19.6337 18.4943 18.4802 19.4832 17.0001C20.4722 15.5201 21 13.78 21 12C21 9.61305 20.0518 7.32387 18.364 5.63604C16.6761 3.94821 14.387 3 12 3ZM12 19.7143C10.4743 19.7143 8.98278 19.2618 7.71418 18.4142C6.44557 17.5665 5.45681 16.3617 4.87293 14.9521C4.28906 13.5425 4.13629 11.9914 4.43395 10.495C4.7316 8.99859 5.46632 7.62404 6.54518 6.54518C7.62404 5.46631 8.9986 4.7316 10.495 4.43394C11.9914 4.13628 13.5425 4.28905 14.9521 4.87293C16.3617 5.4568 17.5665 6.44556 18.4142 7.71417C19.2619 8.98278 19.7143 10.4743 19.7143 12C19.7143 14.046 18.9015 16.0081 17.4548 17.4548C16.0081 18.9015 14.046 19.7143 12 19.7143Z"
        fill="var(--icon-stroke)"
      />
      <path
        d="M12 8C11.2089 8 10.4355 8.2346 9.77772 8.67412C9.11992 9.11365 8.60723 9.73836 8.30448 10.4693C8.00173 11.2002 7.92252 12.0044 8.07686 12.7804C8.2312 13.5563 8.61216 14.269 9.17157 14.8284C9.73098 15.3878 10.4437 15.7688 11.2196 15.9231C11.9956 16.0775 12.7998 15.9983 13.5307 15.6955C14.2616 15.3928 14.8864 14.8801 15.3259 14.2223C15.7654 13.5645 16 12.7911 16 12C16 10.9391 15.5786 9.92172 14.8284 9.17157C14.0783 8.42143 13.0609 8 12 8Z"
        fill="var(--icon-stroke)"
      />
    </svg>
  );
}

function YesNoIcon({ width = 24, height = 24, ...props }) {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width={24} height={24} rx="4" fill="var(--icon-fill)" />
      <path d="M20.9997 15.7454H19.6629L15.5462 9.68604V15.7454H14.1621V7.25464H15.5817L19.6156 13.1486V7.25464H20.9997V15.7454Z" fill="var(--icon-stroke)" />
      <path d="M10.5135 16H9.59082L12.3945 7H13.3172L10.5135 16Z" fill="var(--icon-stroke)" />
      <path d="M7.44799 15.7454H6.06391V12.2193L3 7.25464H4.58519L6.76186 10.8954L8.91488 7.25464H10.5001L7.44799 12.2193V15.7454Z" fill="var(--icon-stroke)" />
    </svg>
  );
}
